exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/DAPPS/asch-paperwallet/paperwallet/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/DAPPS/asch-paperwallet/paperwallet/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/DAPPS/asch-paperwallet/paperwallet/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles